// extracted by mini-css-extract-plugin
export default {"HeaderButton":"HeaderButtonStyle_HeaderButton__NrzuV","HeaderButton_Text":"HeaderButtonStyle_HeaderButton_Text__FXULM"};